/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSelector } from "@reduxjs/toolkit";
import { selectSelfCombine } from "./self.selector";
export const getMapCombineModel = createSelector(
    selectSelfCombine,
    (state) => state.mapCombineModel
);
